<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="head1"><span class="small">PRAISE FOR</span> KATE GRENVILLE</p>
<p class="head2"><span class="small">AND</span> <em class="italic">THE LIEUTENANT</em></p>
<p class="cent">‘It glows with life: imaginative in its recreations, respectful of what cannot be imagined, and thoughtful in its interrogation of the past.’ <em class="italic">Age</em></p>
<p class="cent">‘Dry, exact and lush all at once, this book is Grenville at her best.’ <em class="italic">West Australian</em></p>
<p class="cent">‘A supremely good novel.’ DIANA ATHILL</p>
<p class="cent">‘Grenville’s craft is, as always, astounding, deftly melding subject and metaphor, story and image…<em class="italic">The Lieutenant </em>succeeds beautifully.’ <em class="italic">Canberra Times</em></p>
<p class="cent">‘Elegantly calibrated prose…a lovely, watchful stillness: a sort of astronomy of the human heart.’ <em class="italic">Sunday Telegraph</em></p>
<p class="cent">‘Grenville writes with a poet’s sense of rhythm and imagery.’ <em class="italic">Guardian</em></p>
<p class="cent">‘In lucid prose and perfectly measured strides, Grenville lays down her riveting tale. A novel aglow with empathy, its author’s capacious visions still deliver an elemental thrill.’ <em class="italic">Daily Mail</em></p>
<p class="cent">‘A profoundly uplifting novel.’ <em class="italic">Independent</em></p>
<p class="cent">‘This novel is a triumph. Read it at once.’ <em class="italic">The Times</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Praise_For_Kate_Grenville1.vue?26bc5fdf